export const getGroupTermsForGroup = state => groupId => {
    const group = getGroup(state)(groupId)
    return group.groupTerms.map( id => state.groups.terms[id] )
}

export const getCurrentGroupTermForGroup = state => groupId => {
    const group = getGroup(state)(groupId)
    if ( group.currentGroupTerm == null ) {
        return null
    }
    return state.groups.terms[ group.currentGroupTerm[0] ]
}


export const getCurrentGroupPeriodForGroupTerm = state => groupTerm => {
    return state.groups.periods[  getCurrentGroupPeriodIdForGroupTerm(groupTerm) ]
}

const getCurrentGroupPeriodIdForGroupTerm = groupTerm => {
    // if no period is currently active, fallback to last period in current term
    return groupTerm.currentGroupPeriod == null ?
            groupTerm.groupPeriods[ groupTerm.groupPeriods.length - 1 ] :
             groupTerm.currentGroupPeriod[0]
}

export const getCurrentPeriodIdForGroup = state => groupId => {
    return getCurrentGroupPeriodForGroup(state)(groupId).period[0]
}

export const getCurrentGroupPeriodIdForGroup = state => groupId => {
    const groupTerm = getCurrentGroupTermForGroup(state)(groupId)
    if ( groupTerm == null ) {
        return null
    }
    return getCurrentGroupPeriodIdForGroupTerm(groupTerm)
}

export const getCurrentGroupPeriodForGroup = state => groupId => {
    const groupTerm = getCurrentGroupTermForGroup(state)(groupId)
    if ( groupTerm == null ) {
        return null
    }
    return getCurrentGroupPeriodForGroupTerm(state)(groupTerm)
}

export const getCurrentTermId = state => groupId => {
    const groupTerm = getCurrentGroupTermForGroup(state)(groupId)
    if ( groupTerm == null ) {
        return null
    }
    return groupTerm.term[0]
}

export const getCurrentTerm = state => groupId => {
    const termId = getCurrentTermId(state)(groupId)
    return termId == null ? null : state.terms.storage[ termId ]
}

export const getGroup = state => id => state.groups.storage[id]
export const getGroupIdForCurrentUser = state => getCurrentUser(state).groups[0]
export const getCurrentUser = state => state.users.current

export const getCurrentAssignment = state => state.assignments.storage[ state.assignments.currentId ]


export const getTermForPeriod = state => periodId => {
    return Object.keys(state.terms.storage)
        .map( id => state.terms.storage[ id ])
        .find( t => t.periods.indexOf(periodId) !== -1 )
}

export const getProgressForUserAssignmentGroup = state => (userId, assignmentId, groupId) => {
    return getProgressForUser(state)(userId)
        .find( progress => progress.assignment == assignmentId && progress.group == groupId )
}

export const getProgressForUser = state => userId => {
    return Object.keys(state.progress.storage)
        .map( id => state.progress.storage[id] )
        .filter( progress => progress.user == userId )
}

export const getProgressForUserAndGroupTerm = state => (userId, groupTermId, groupId) => {
    const termAssignments = getAssignmentIdsForGroupTerm(state)(groupTermId)
    return getProgressForUser(state)(userId)
        .filter( p => termAssignments.indexOf( p.assignment ) !== -1
            && p.group == groupId)
}

const getAssignmentIdsForGroupTerm = state => (groupTermId, filterOptional) => {
    return state.groups.terms[ groupTermId ].groupPeriods
        .map( gp => getAssignmentIdsForGroupPeriod(state)(gp, filterOptional) )
        .reduce( (list, assignments) => list.concat(assignments), [] ) // flatmap to AssignmentIds
}

const getAssignmentIdsForGroupPeriod = state => (groupPeriodId, filterOptional) => {
    return state.groups.periods[ groupPeriodId ].groupAssignments
        .map( id => state.groups.assignments[id] ) // map to GroupAssignment
        .filter( ga => !(filterOptional && ga.optional) )
        .map ( ga => ga.assignment[0]) // map to AssignmentId
}

export const getAssignmentsForGroupPeriod = state => (groupPeriodId, filterOptional) => {
    return getAssignmentIdsForGroupPeriod(state)(groupPeriodId, filterOptional)
        .map( id => state.assignments.storage[id] )
}



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/getters.js